import { render, staticRenderFns } from "./AdmissionNote.vue?vue&type=template&id=3d7be802&"
import script from "./AdmissionNote.vue?vue&type=script&lang=js&"
export * from "./AdmissionNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports